import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import SiteHeader from "@/components/site/SiteHeader";
import SiteFooter from "@/components/site/SiteFooter";
import FloatingConsultationCta from "@/components/site/FloatingConsultationCta";

export default function SiteLayout() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname, location.search]);

  // On the consultation booking page the page itself IS the booking; the floating button is redundant.
  const hideFloating = location.pathname === "/book-consultation";

  return (
    <div className="min-h-screen flex flex-col wt-bg">
      <SiteHeader />
      <main data-testid="site-main" className="flex-1 has-floating-cta">
        <Outlet />
      </main>
      <SiteFooter />
      {!hideFloating && <FloatingConsultationCta />}
    </div>
  );
}
